module.exports = __webpack_public_path__ + "img/ResearchIcon.3335ef38.png";